import React, { ChangeEvent, FC } from 'react';

import { HiddenCheckbox } from '../Checkbox';

import { LabelTextHolder, SwitchLabel, SwitchWrapper, TooltipWrapper, Wrapper } from './Wrapper';

export { Wrapper as SwitchWrapper };

export type SwitchHandler = (event: ChangeEvent<HTMLInputElement>) => void;

export type SwitchVariant = 'form-inline' | 'form-inline-last-item' | 'form-inline-last-item-reverse';

export type SwitchProps = {
  checked: boolean;
  onChange: SwitchHandler;
  label?: string;
  isBeta?: boolean;
  variant?: SwitchVariant;
  inActive?: boolean;
  disabled?: boolean;
  className?: string;
  renderTooltip?: () => JSX.Element;
};

const Switch: FC<SwitchProps> = ({
  label,
  isBeta,
  variant,
  checked,
  onChange,
  inActive = false,
  disabled = false,
  className,
  renderTooltip
}) => (
  <Wrapper {...{ disabled, variant, inActive, hasTooltip: !!renderTooltip }}>
    <TooltipWrapper variant="white" renderContent={renderTooltip}>
      <SwitchLabel>
        <HiddenCheckbox {...{ checked, onChange, disabled }} />
        <SwitchWrapper className={className} {...{ checked, disabled }} />
        {label && (
          <LabelTextHolder
            {...{
              isBeta,
              checked,
              disabled,
              ...(typeof label === 'string'
                ? {
                    dangerouslySetInnerHTML: { __html: label }
                  }
                : { children: label })
            }}
          />
        )}
      </SwitchLabel>
    </TooltipWrapper>
  </Wrapper>
);

export default Switch;
